import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    company: [
      { label: 'About Us', path: '/about-us' },
      // { label: 'Our Team', path: '/Our-team' },
      { label: 'Careers', path: '/careers' },
      { label: 'Contact', path: '/contact' }
    ],
    services: [
      { label: 'Web Development', path: '/Services' },
      { label: 'Mobile Apps', path: '/Services' },
      { label: 'Cloud Solutions', path: '/Services' },
      { label: 'Consulting', path: '/Services' }
    ],
    resources: [
      { label: 'Blog', path: '/blog' },
      { label: 'Portfolio', path: '/Portfolio' },
      { label: 'Case Studies', path: '/Portfolio' },
      { label: 'Documentation', path: '/docs-page' }
    ],
    legal: [
      { label: 'Privacy Policy', path: '/privacy-page' },
      { label: 'Terms of Service', path: '/terms-page' },
      { label: 'Cookie Policy', path: '/cookies-page' },
      { label: 'GDPR', path: '/gdpr-page' }
    ]
  };

  const socialLinks = [
    { name: 'LinkedIn', icon: 'Linkedin', url: 'https://www.linkedin.com/company/zentirx', color: 'hover:text-blue-600' },
    { name: 'Twitter', icon: 'Twitter', url: 'https://twitter.com/zentirxinfotech', color: 'hover:text-blue-400' },
    { name: 'GitHub', icon: 'Github', url: 'https://github.com/zentirx-infotech', color: 'hover:text-gray-900' },
    // { name: 'Instagram', icon: 'Instagram', url: 'https://instagram.com/zentirxinfotech', color: 'hover:text-pink-600' },
    // { name: 'Facebook', icon: 'Facebook', url: 'https://facebook.com/zentirxinfotech', color: 'hover:text-blue-700' }
  ];

  const contactInfo = {
    address: "35, Meridian Business Center (MBC), Lajamani chowk, Motavarachha (Digital Valley),Surat",
    phone: "+91 99256 27972",
    phone2: "+91 88666 25488",
    email: "info@zentirx.com",
    businessHours: "Mon - Sat: 9:00 AM - 7:00 PM IST", 
  };

  return (
    <footer className="bg-secondary-800 text-white">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <div className="mb-6">
              <Link to="/home" className="flex items-center space-x-3">
                {/* <div className="w-10 h-10 bg-primary rounded-lg flex items-center justify-center">
                  <svg
                    className="w-6 h-6 text-white"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12 2L2 7L12 12L22 7L12 2Z"
                      stroke="currentColor"
                      strokeWidth="2" 
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M2 17L12 22L22 17"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M2 12L12 17L22 12"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div> */}
                <div>
                  {/* <span className="text-xl font-bold">Zentirx</span>
                  <span className="text-sm text-secondary-300 block -mt-1">Infotech</span> */}
                  <img src="/zentirx_logo.png"  className="h-20 w-auto select-none" />
                </div>
              </Link>
            </div>
            
            <p className="text-secondary-300 mb-6 leading-relaxed">
              Transforming ideas into digital excellence. We create innovative software solutions that drive business growth and deliver exceptional user experiences.
            </p>

            {/* Social Links */}
            <div className="flex space-x-4">
              {socialLinks.map((social) => (
                <a
                  key={social.name}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`w-10 h-10 bg-secondary-700 rounded-lg flex items-center justify-center text-secondary-300 ${social.color} transition-all duration-300 hover:scale-110 hover:shadow-lg`}
                  aria-label={`Follow us on ${social.name}`}
                >
                  <Icon name={social.icon} size={20} />
                </a>
              ))}
            </div>
          </div>

          {/* Links Sections */}
          <div className="lg:col-span-2">
            <div className="grid grid-cols-2 md:grid-cols-3 gap-8">
              {/* Company Links */}
              <div>
                <h3 className="text-lg font-semibold mb-4">Company</h3>
                <ul className="space-y-3">
                  {footerLinks.company.map((link) => (
                    <li key={link.label}>
                      <Link
                        to={link.path}
                        className="text-secondary-300 hover:text-white transition-colors duration-300"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Services Links */}
              <div>
                <h3 className="text-lg font-semibold mb-4">Services</h3>
                <ul className="space-y-3">
                  {footerLinks.services.map((link) => (
                    <li key={link.label}>
                      <Link
                        to={link.path}
                        className="text-secondary-300 hover:text-white transition-colors duration-300"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Resources Links */}
              <div>
                <h3 className="text-lg font-semibold mb-4">Resources</h3>
                <ul className="space-y-3">
                  {footerLinks.resources.map((link) => (
                    <li key={link.label}>
                      <Link
                        to={link.path}
                        className="text-secondary-300 hover:text-white transition-colors duration-300"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          {/* Contact Info */}
          <div className="lg:col-span-1">
            <h3 className="text-lg font-semibold mb-4">Get in Touch</h3>
            
            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <Icon name="MapPin" size={20} className="text-primary mt-1 flex-shrink-0" />
                <p className="text-secondary-300 text-sm leading-relaxed">
                  {contactInfo.address}
                </p>
              </div>

              <div className="flex items-center space-x-3">
                <Icon name="Phone" size={20} className="text-primary flex-shrink-0" />
                <div className='flex flex-col'>
                  <a
                    href={`tel:${contactInfo.phone}`}
                    className="text-secondary-300 hover:text-white transition-colors duration-300"
                    >
                    {contactInfo.phone}
                  </a>
                  <a
                    href={`tel:${contactInfo.phone2}`}
                    className="text-secondary-300 hover:text-white transition-colors duration-300"
                    >
                    {contactInfo.phone2}
                  </a>
                  </div>
              </div>

              <div className="flex items-center space-x-3">
                <Icon name="Mail" size={20} className="text-primary flex-shrink-0" />
                <a
                  href={`mailto:${contactInfo.email}`}
                  className="text-secondary-300 hover:text-white transition-colors duration-300"
                >
                  {contactInfo.email}
                </a>
              </div>

              <div className="flex items-start space-x-3">
                <Icon name="Clock" size={20} className="text-primary mt-1 flex-shrink-0" />
                <p className="text-secondary-300 text-sm">
                  {contactInfo.businessHours}
                </p>
              </div>
            </div>

            {/* Quick Contact CTA */}
            <div className="mt-6">
              <Link
                to="/contact"
                className="inline-flex items-center px-4 py-2 bg-primary text-white font-medium rounded-lg hover:bg-primary-700 transition-colors duration-300"
              >
                <Icon name="MessageCircle" size={16} className="mr-2" />
                Start a Project
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Footer */}
      <div className="border-t border-secondary-700">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            {/* Copyright */}
            <div className="text-secondary-300 text-sm">
              <p>
                © {currentYear} Zentirx Infotech. All rights reserved.
              </p>
            </div>

            {/* Legal Links */}
            <div className="flex flex-wrap justify-center md:justify-end space-x-6">
              {footerLinks.legal.map((link, index) => (
                <React.Fragment key={link.label}>
                  <Link
                    to={link.path}
                    className="text-secondary-300 hover:text-white text-sm transition-colors duration-300"
                  >
                    {link.label}
                  </Link>
                  {index < footerLinks.legal.length - 1 && (
                    <span className="text-secondary-600">|</span>
                  )}
                </React.Fragment>
              ))}
            </div>
          </div>

          {/* Additional Info */}
          <div className="mt-4 pt-4 border-t border-secondary-700 text-center">
            <p className="text-secondary-400 text-xs">
              Built with ❤️ in India by Zentirx | Serving clients worldwide
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;